import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { useValidation } from 'gw-portals-validation-react';
import { fnolCommonMessages } from 'gw-capability-fnol-common-react';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './WindDamagePage.metadata.json5';
import LossPropertyIncidentDetail from './../LossPropertyIncidentDetails/LossPropertyIncidentDetails';

function FNOLWindDamagePage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        }
    } = props;
    const { claimStatus } = state;
    const translator = useContext(TranslatorContext);

    const {
        onValidate,
        initialValidation,
        isComponentValid,
        registerInitialComponentValidation
    } = useValidation('FNOLHOWindDamagePage');

    const initialiseVM = useCallback(() => {

        claimVM.lobs.homeowners.propertyWindDamage.value = !_.isEmpty(
            claimVM.lobs.homeowners.propertyWindDamage.value
        )
            ? claimVM.lobs.homeowners.propertyWindDamage.value
            : {
                isRoofDamageTarped: false,
                isHomeSecure: false,
                isHomeHabitable: false
            };
        if (_.isNil(_.get(claimVM.value, 'lobs.homeowners.propertyWindDamage.isRoofDamageTarped'))) {
            _.set(claimVM.value, 'lobs.homeowners.propertyWindDamage.isRoofDamageTarped', '');
        }
        if (_.isNil(_.get(claimVM.value, 'lobs.homeowners.propertyWindDamage.isHomeSecure'))) {
            _.set(claimVM.value, 'lobs.homeowners.propertyWindDamage.isHomeSecure', '');
        }
        if (_.isNil(_.get(claimVM.value, 'lobs.homeowners.propertyWindDamage.isHomeHabitable'))) {
            _.set(claimVM.value, 'lobs.homeowners.propertyWindDamage.isHomeHabitable', '');
        }


        return claimVM;
    }, [claimVM]);

    useEffect(
        () => {
            const nextclaimVM = initialiseVM(claimVM);
            updateWizardData(nextclaimVM);
        },
        // It should call once when page gets rendered
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const isClaimStatus = useCallback(() => {
        return _.get(claimVM.value, 'lossCause') === 'windDamage' && !_.isEmpty(claimStatus);
    }, [claimStatus, claimVM]);

    useEffect(() => {
        registerInitialComponentValidation(isClaimStatus);
    }, [registerInitialComponentValidation, isClaimStatus]);

    const overrides = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        propertyID: {
            //model: claimVM.lobs.homeowners.incidents,
            propertyOtherDamageVM: claimVM.lobs.homeowners.propertyOtherDamage,
            isComponentValid: isComponentValid,
            onIncidentUpdates: (value) => {
                _.set(claimVM, `lobs.homeowners.propertyOtherDamage.value`, value);
                updateWizardData(claimVM);
            }
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrides);
        },
        [claimVM, overrides]
    );

    const resolvers = {
        resolveComponentMap: {losspropertyincidentdetail: LossPropertyIncidentDetail}
    }

    return (
        <WizardPage
            cancelLabel={translator(fnolCommonMessages.fnolSaveandExit)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={!isComponentValid}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                resolveValue={readValue}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

FNOLWindDamagePage.propTypes = wizardProps;
export default withRouter(FNOLWindDamagePage);
